import Api from "../config/api";

export const createExameWorkList = async (variables) => {
  const response = await Api.post("", {
    query: `mutation CreateExameWorkList($profissinalId: Long, $sujeitoAtencaoId: UUID, $exames: [ExameInput]) {
  createExameWorkList(profissinalId: $profissinalId, sujeitoAtencaoId: $sujeitoAtencaoId, exames: $exames) {
    codigo
    mensagem
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.createExameWorkList;
}

export const findAllExamesPacsweb = async (variables) => {
  const response = await Api.post("", {
    query: `query ($sujeitoAtencaoId: UUID, $pageableDto: PageableDTOInput, $search: String, $profissionalSaudeId: Long) {
  findAllExamesPacsweb(sujeitoAtencaoId: $sujeitoAtencaoId, pageableDto: $pageableDto, search: $search, profissionalSaudeId: $profissionalSaudeId) {
    content {
      sujeitoAtencao {
        nome
        id
      }
      status
      id
      exameNome
      exameCodigo
      modalidade
      profissionalSaude {
        nome
        id
      }
      atendimentoDataHora
      laudoGerado
      studyIuid
      pacienteAnexo {
        id
      }
    }
    last
  }
}`, variables
  })

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findAllExamesPacsweb;

}

export const obterLaudoPdf = async (variables) => {
  const response = await Api.post("", {
    query: `query($accessionNumber: Long, $studyIuid: Long) {
  obterLaudoPdf(accessionNumber: $accessionNumber, studyIuid: $studyIuid)
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.obterLaundoPdf;
}

export const buscarResultadoExame = async (exameId) => {
  const response = await Api.post("", {
    query: `mutation BuscarResultadoExame($exameId: Long!) {
      buscarResultadoExame(exameId: $exameId)
    }`,
    variables: { exameId },
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.buscarResultadoExame;
}

export const findAllModalidadeExame = async () => {
  const response = await Api.post("", {
    query: `query FindAllModalidadeExame {
  findAllModalidadeExame {
    descricao
    codigo
  }
}`,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findAllModalidadeExame;
}

export const findProcedimentosByModalidade = async (variables) => {
  const response = await Api.post("", {
    query: `query FindProcedimentosByModalidade($modeloExameCodigo: String) {
  findProcedimentosByModalidade(modeloExameCodigo: $modeloExameCodigo) {
    nome
    id
    modalidadeExames {
      codigo
      descricao
    }
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findProcedimentosByModalidade;
}

export const atualizarProcedimentosModalidadeExame = async (variables) => {
  const response = await Api.post("", {
    query: `mutation AtualizarProcedimentosModalidadeExame($codigo: String, $procedimentosIds: [UUID]) {
  atualizarProcedimentosModalidadeExame(codigo: $codigo, procedimentosIds: $procedimentosIds) {
    descricao
    codigo
    procedimentos {
      id
      nome
    }
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.atualizarProcedimentosModalidadeExame;
}